// React
import React, { useRef, useEffect, useContext, useState } from "react";
// React
// CSS
import styles from "./AddCommentsModal.module.css";
// CSS
// Contexts
import { UserTokenContext } from "../../../../Contexts/userToken";
import { newCommentLogo } from "../../../../Images/images";
import HelperHeader from "../../../../Utils/HelperHeader/HelperHeader";
import { addCommentToTeachItemService } from "../../../../Services/parts/post/addCommentToTeachItemService";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import Spinner from "../../../../Utils/Spinner/Spinner";
// Contexts

type AddCommentsModalProps = {
  setIsModalInScreen: React.Dispatch<React.SetStateAction<boolean>>;
  _lessonData: string;
  teacherName: string;
  sectionId: string | number;
};

const AddCommentsModal: React.FunctionComponent<AddCommentsModalProps> = ({
  setIsModalInScreen,
  _lessonData,
  teacherName,
  sectionId,
}) => {
  const [isPending, setIsPending] = useState<boolean>(false);

  const userToken = useContext(UserTokenContext);

  const innerRef = useRef<HTMLDivElement>(null);
  const outerRef = useRef<HTMLDivElement>(null);

  const [inputValue, setInputValue] = useState<string>("");

  useEffect(() => {
    setTimeout(() => {
      if (!innerRef.current) return;
      if (!outerRef.current) return;
      innerRef.current.style.top = "0%";
      outerRef.current.style.opacity = "0.5";
    }, 50);
  }, []);

  const closeModal = () => {
    if (!innerRef.current) return;
    if (!outerRef.current) return;

    innerRef.current.style.top = "80vh";
    outerRef.current.style.opacity = "0";

    setTimeout(() => {
      setIsModalInScreen(false);
    }, 500);
  };

  return (
    <div
      className={`${styles.modalContainer} fixed top-0 left-0 w-screen h-screen z-30 flex items-center justify-center rounded-xl`}
    >
      <div
        className={`${styles.outer} absolute w-screen h-screen z-40 `}
        ref={outerRef}
        onClick={closeModal}
      ></div>
      <div
        className={`${styles.inner} flex flex-col items-center justify-center mx-4 rounded-xl relative z-50 w-screen bg-customColor p-4`}
        ref={innerRef}
      >
        <HelperHeader
          absoluteText="ثـــبت نـــظر"
          className="text-white before:!bg-customColor !bg-white "
          isBgWhite={true}
        />
        <img src={newCommentLogo} alt="" className="my-6" />
        <p className="w-full text-right text-white mt-2" id={styles.lessonName}>
          {_lessonData}
        </p>
        <p className="w-full text-right text-white mt-2">
          <span>مدرس : </span>
          <span>{teacherName}</span>
        </p>
        <textarea
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
            setInputValue(e.target.value);
          }}
          className="bg-white mt-4 rounded-xl p-2"
          placeholder="نظر خود را بنویسید ..."
          value={inputValue}
        ></textarea>
        <button
          className={`${styles.submitBtn} w-full text-center text-white mt-4 rounded-xl py-2 flex items-center justify-center `}
          onClick={() => {
            if (isPending) return;
            if (inputValue.length > 71) {
              closeModal();
              toast("نظر خود را کوتاه تر و خلاصه تر بنویسید", {
                type: "info",
                style: {
                  zIndex: 900000,
                },
              });
              return;
            }
            setIsPending(true);
            if (inputValue.trim().length <= 4) {
              toast("نظر خود را کامل وارد کنید");
              setIsPending(false);
              return;
            }
            addCommentToTeachItemService(
              userToken,
              String(sectionId),
              inputValue
            )
              .then(({ data }) => {
                setIsPending(false);
                closeModal();
                toast("نظر شما پس از تایید نمایش داده میشود");
              })
              .catch((err) => {
                setIsPending(false);
                console.log(err);
                Swal.fire({
                  icon: "error",
                  title: err.message,
                });
              });
          }}
        >
          {isPending ? (
            <>
              <Spinner />
            </>
          ) : (
            <>ثبت نظر</>
          )}
        </button>
      </div>
    </div>
  );
};

export default AddCommentsModal;
